// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SideBar_sidebar__13-MR","close":"SideBar_close__3xDN0","open":"SideBar_open__2k7CX","hamburger":"SideBar_hamburger__12grl"};